"use client";
import SectionHeader from "@/components/SectionHeader";
import { useEffect, useState } from "react";
import TabSwitcher from "../../components/TabSwitcher";
import CountryColumn from "./CountryColumn";
import EmptyState from "./EmptyState";

export default function ContinentTabsClient({ continents = [] }) {
  // TabSwitcher için tabs formatına çevir
  const tabs = continents
    .filter((continent) => continent.ContinentCode && continent.ContinentName)
    .map((continent) => ({
      id: continent.ContinentCode,
      label: continent.ContinentName,
    }));

  const [activeContinent, setActiveContinent] = useState(tabs[0]?.id || "");

  const [columns, setColumns] = useState(2);

  useEffect(() => {
    const updateColumns = () => {
      const width = window.innerWidth;
      let newColumns = 2;
      if (width >= 1280) {
        newColumns = 5; // xl: 5 columns
      } else if (width >= 1024) {
        newColumns = 4; // lg: 4 columns
      } else if (width >= 768) {
        newColumns = 3; // md: 3 columns
      } else {
        newColumns = 2; // mobile: 2 columns
      }
      setColumns(newColumns);
    };

    updateColumns();
    window.addEventListener("resize", updateColumns);
    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  if (!continents || continents.length === 0) {
    return (
      <EmptyState
        title="Havalimanı Bulunamadı"
        description="Şu anda görüntülenecek havalimanı bulunmamaktadır."
      />
    );
  }

  const activeContinentData = continents.find(
    (continent) => continent.ContinentCode === activeContinent,
  );

  return (
    <div className="flex w-full flex-col gap-4 lg:gap-8">
      <div className="flex w-full flex-col gap-4">
        {" "}
        <SectionHeader title="Tüm Havalimanları" />
        {tabs.length > 1 && (
          <div className="">
            <TabSwitcher
              tabs={tabs}
              selected={activeContinent}
              onChange={setActiveContinent}
              className=""
            />
          </div>
        )}
      </div>

      {/* Active Continent Content */}
      <div
        role="tabpanel"
        id={`continent-${activeContinent}`}
        aria-labelledby={`tab-${activeContinent}`}
        className="w-full"
      >
        {activeContinentData && activeContinentData.Countries ? (
          <div
            style={{
              columns: columns,
              columnFill: "balance",
              columnGap: "32px",
              columnRule: "none",
              orphans: 2,
              widows: 2,
            }}
          >
            {activeContinentData.Countries.map((country) => (
              <div
                key={country.CountryCode}
                className="mb-8"
                style={{
                  pageBreakInside: "avoid",
                  breakInside: "avoid",
                }}
              >
                <CountryColumn country={country} />
              </div>
            ))}
          </div>
        ) : (
          <EmptyState
            title="Ülke Bulunamadı"
            description="Bu kıtada görüntülenecek ülke bulunmamaktadır."
          />
        )}
      </div>
    </div>
  );
}
